'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = exports.wrapDisplayName = undefined;

var _reactRedux = require('react-redux');

var _device = require('redux/modules/device');

var mapMediaState = function mapMediaState(mediaState) {
  return {
    mediaQueryXs: mediaState.xs,
    mediaQuerySm: mediaState.sm,
    mediaQueryMd: mediaState.md,
    mediaQueryLg: mediaState.lg,
    mediaQueryXl: mediaState.xl,
    mediaQueryXxl: mediaState.xxl
  };
};

var wrapDisplayName = exports.wrapDisplayName = function wrapDisplayName(ConnectedComponent, displayName) {
  ConnectedComponent.displayName = 'media(' + (displayName || ConnectedComponent.displayName.replace(/^Connect\((.*)\)$/, '$1')) + ')';
  return ConnectedComponent;
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return mapMediaState((0, _device.selectMediaState)(state));
};

exports.default = function (Component, displayName) {
  return wrapDisplayName((0, _reactRedux.connect)(mapStateToProps)(Component), displayName);
};